<template>
  <VPanel class="relative p-6 overflow-hidden">
    <div class="flex justify-between">
      <h1 class="text-lg">مدیریت زبان ها</h1>

      <a href="#" @click.prevent="modalLanguage = true; editLanguage = {}"
         class="flex items-center border border-dark-line rounded-lg px-4 py-3 hover:bg-accent">
        <PlusIcon class="ml-2"/>
        زبان جدید
      </a>
    </div>
    <hr class="border-dark-line mt-6">

    <table class="w-full text-right mt-4">
      <thead>
      <tr class="text-sm text-muted">
        <th class="p-4">ردیف</th>
        <th>نام</th>
        <th>کد</th>
        <th>وضعیت</th>
        <th>عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(language, index) in languages"
          :key="language.id">
        <td class="p-8">{{ index + 1 }}</td>
        <td>{{ language.name }}</td>
        <td>
          <span class="border rounded-lg py-0.5 px-3">{{ language.code }}</span>
        </td>
        <td>
          <VBadge :type="language.active ? 'success' : 'danger'">
            {{ language.active ? 'فعال' : 'غیرفعال' }}
          </VBadge>
        </td>
        <td>
          <div class="flex gap-x-2">
            <a href="#" @click.prevent="editLanguage = language; modalLanguage = true">
              <PenIcon class="text-orange"/>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <ModalLanguage
        :show="modalLanguage"
        :language="editLanguage"
        @click="modalLanguage = !modalLanguage"
        @created="languageCreated"
        @edited="languageEdited"/>

  </VPanel>
</template>

<script>
import VBadge from "@/components/General/VBadge.vue";
import PenIcon from "@/components/Icons/PenIcon.vue";
import PlusIcon from "@/components/Icons/PlusIcon.vue";
import VPanel from "@/components/VPanel.vue";
import {getLanguages} from "@/API/API";
import ModalLanguage from "@/components/Modal/ModalLanguage.vue";

export default {
  name: "LanguageView",
  components: {ModalLanguage, PenIcon, VBadge, PlusIcon, VPanel},
  data() {
    return {
      languages: [],
      loading: true,

      modalLanguage: false,

      editLanguage: {},
    }
  },
  async created() {
    this.languages = (await getLanguages()).data
    this.loading = false
  },
  methods: {
    languageCreated(language) {
      this.modalLanguage = false
      this.languages.unshift(language)
      this.$store.dispatch('getLanguages')
    },
    languageEdited(language) {
      this.modalLanguage = false
      let index = this.languages.findIndex(item => item.id === language.id)
      this.languages[index] = language
      this.$store.dispatch('getLanguages')
    }
  }
}
</script>

<style scoped>

</style>